import { ArrowIosDownward } from "@styled-icons/evaicons-solid/ArrowIosDownward";
import { CollapseProps, theme } from "antd";
import React from "react";

import { CollapseStyled } from "./styled";

export const ESAccordion: React.FC<CollapseProps> = (props) => {
  const { token } = theme.useToken();

  return (
    <CollapseStyled
      {...props}
      expandIcon={(props) => (
        <ArrowIosDownward
          height={32}
          fill={token.colorPrimary}
          style={{
            transform: `rotate(${props.isActive ? "180" : "0"}deg)`,
          }}
        />
      )}
      expandIconPosition="end"
      accordion
      ghost
    />
  );
};
